import { render, staticRenderFns } from "./training-list.vue?vue&type=template&id=649a0a24&scoped=true"
import script from "./training-list.vue?vue&type=script&lang=js"
export * from "./training-list.vue?vue&type=script&lang=js"
import style0 from "./training-list.vue?vue&type=style&index=0&id=649a0a24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649a0a24",
  null
  
)

export default component.exports